var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 15.6v-3.2c-1.7-.6-2.7-.8-3.2-2-.5-1.3.1-2.1.8-3.7l-2.3-2.3c-1.6.7-2.4 1.4-3.7.8-1.3-.5-1.4-1.6-2-3.2h-3.2c-.6 1.6-.7 2.7-2 3.2s-2.2-.1-3.7-.8L4.4 6.7c.7 1.6 1.4 2.4.8 3.7-.5 1.3-1.6 1.4-3.2 2v3.2c1.6.6 2.7.7 3.2 2s-.1 2.2-.8 3.7l2.3 2.3c1.6-.7 2.4-1.4 3.7-.8 1.3.5 1.4 1.6 2 3.2h3.2c.6-1.6.7-2.7 2-3.2s2.1.1 3.7.9l2.3-2.3c-.7-1.6-1.4-2.4-.8-3.7.5-1.3 1.6-1.5 3.2-2.1zM14 18c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z",
    fill: "currentColor"
  })));
}

export default SvgIconSettings;